var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchicon = function SvgSearchicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#121212",
    d: "M2 7.5C2 4.468 4.468 2 7.5 2S13 4.468 13 7.5 10.532 13 7.5 13 2 10.532 2 7.5m16 9.086-4.545-4.545A7.45 7.45 0 0 0 15 7.5C15 3.364 11.636 0 7.5 0S0 3.364 0 7.5 3.364 15 7.5 15a7.45 7.45 0 0 0 4.541-1.545L16.586 18z"
  })));
};
export { SvgSearchicon as ReactComponent };
export default __webpack_public_path__ + "1e3549096f6f702b935b80ccadb39ad0.svg";